import script from "./DigitalFiberMesh.vue?vue&type=script&setup=true&lang=js"
export * from "./DigitalFiberMesh.vue?vue&type=script&setup=true&lang=js"

import "./DigitalFiberMesh.vue?vue&type=style&index=0&id=d21fef4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d21fef4e"]])

export default __exports__